import type { UndrawScene } from '@/lib/undraw-illustrations';
import { getUndrawSvg } from '@/lib/undraw-illustrations';
import { cn } from '@/lib/utils';

export type UndrawIllustrationProps = {
  scene: UndrawScene;
  /** Accessible name when the illustration conveys meaning (e.g. empty state). */
  title?: string;
  /** Decorative only — hidden from assistive tech. */
  decorative?: boolean;
  className?: string;
};

export function UndrawIllustration({
  scene,
  title,
  decorative = false,
  className,
}: UndrawIllustrationProps) {
  const svg = getUndrawSvg(scene);
  const labelProps =
    decorative || !title
      ? { 'aria-hidden': true as const }
      : { role: 'img' as const, 'aria-label': title };

  return (
    <div
      {...labelProps}
      className={cn('text-primary [&_svg]:h-full [&_svg]:w-full [&_svg]:max-h-full', className)}
      // SVG markup is bundled from undraw-svg (trusted dependency), not user input.
      dangerouslySetInnerHTML={{ __html: svg }}
    />
  );
}
